export default {
  state: {
    enabled: false,
    targetEntryId: null,
    visualRigMode: false
  },
  getters: {
    riggingEnabled: state => state.enabled,
    rigTargetEntryId: state => state.targetEntryId,
    visualRigMode: state => state.visualRigMode
  },
  mutations: {
    setRiggingEnabled(state, enabled) {
      state.enabled = enabled;
    },
    setRigTargetEntryId(state, entryId) {
      state.targetEntryId = entryId;
    },
    setVisualRigMode(state, enabled) {
      state.visualRigMode = enabled;
    }
  },
  actions: {
    resetRigging({ commit }) {
      commit('setRiggingEnabled', false);
      commit('setRigTargetEntryId', null);
      commit('setVisualRigMode', false);
    }
  }
};
